import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { PERSISTENCY_MODULE_CONFIG } from '../persistency-module-config';
import { ModuleStructureObject } from './interfaces';

@Injectable({
  providedIn: 'root',
})
export class ApiModuleService {
  private http = inject(HttpClient);
  private config = inject(PERSISTENCY_MODULE_CONFIG);

  private url = `${this.config.apiBaseUrl}/api/admin/BackofficeTenderForms`;

  saveModule(id: string, moduleStructure: ModuleStructureObject) {
    return this.http.post<{ id: string }>(`${this.url}`, {
      tenderId: id,
      form: moduleStructure,
      compilableIds: Object.keys(moduleStructure),
    });
  }

  editModule(
    id: string,
    moduleStructure: ModuleStructureObject,
    status: 'Draft' | 'Published' = 'Draft',
  ) {
    return this.http.put(`${this.url}/revision`, {
      tenderId: id,
      form: moduleStructure,
      compilableIds: Object.keys(moduleStructure),
      status: status,
    });
  }

  getModuleStructure(id: string) {
    return this.http.get<{
      id?: string;
      tenderId: string;
      form: ModuleStructureObject;
      revision?: number;
      revisions?: { [key: number]: string }[];
      title?: string;
    }>(`${this.url}?TenderId=${id}`);
  }
}
